import { TreatmentPlanBenefitDto } from "../../../../core/models/http/treatment/treatment-plan-benefits/treatment-plan-benefit-dto";
import { TreatmentPlanBenefit } from "./treatment-plan-benefit";

export const mapTreatmentPlanBenefit = (
  benefit: TreatmentPlanBenefitDto
): TreatmentPlanBenefit => {
  return {
    benefit: benefit.Benefit,
    estimatedNetworkDiscount: benefit.EstimatedNetworkDiscount,
    id: benefit.Id,
    initialTreatmentNetworkDiscount: benefit.InitialTreatmentNetworkDiscount,
    networkDiscount: benefit.NetworkDiscount,
    treatmentPlanId: benefit.TreatmentPlanId,
  };
};
